import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_COLORBAR_RANGE_MODE } from "../components/colorBarComponent/colorbarConstants";

const initialState = {
  "Wind Sensors": {},
  "Shading System": {},
  "Energy Data": {},
  "Solar Sensors": {},
  "Sensor Placement": {},
  "Wind Alarm": {},
  "Daylight Factor": {},
  "PV Panel": {},
  "Wind Turbine": {},
  "Sound Emission": {},
};
const colorbarsSlice = createSlice({
  name: "colorbars",
  initialState,
  reducers: {
    setColorbar: (state, action) => {
      const [category, subcategory, min, max, rangeMode] = action.payload;
      const existing = state[category][subcategory] || {};
      state[category][subcategory] = {
        ...existing,
        min,
        max,
        rangeMode:
          rangeMode ?? existing.rangeMode ?? DEFAULT_COLORBAR_RANGE_MODE,
      };
    },
  },
});

export const { setColorbar } = colorbarsSlice.actions;

export default colorbarsSlice.reducer;
